import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import { Column } from 'components/Table/Table'
import { usePlaces } from 'hooks/usePlaces'
import { ListingPage } from 'components/ListingPage/ListingPage'
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator'
import Place from 'types/model/place'
import { PlacesHeader } from './PlacesHeader'
import { NewPlaceModal } from './NewPlaceModal'

export const Places = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const parameters = new URLSearchParams(location.search)
  const pageIndex = parameters.get('page')
  const query = parameters.get('search')
  const [modal, setModal] = useState({
    right: false,
  })
  const { t } = useTranslation()
  const rowsPerPage = 10

  const { isLoading, error, places, pagination } = usePlaces(
    Number(pageIndex) || 1,
    rowsPerPage,
    query
  )

  const columns: Column<'name' | 'chain.name' | 'city' | 'country'>[] = [
    { id: 'name', label: t('name'), minWidth: 170 },
    {
      id: 'chain.name',
      label: t('chain'),
      minWidth: 170,
    },
    {
      id: 'city',
      label: t('city'),
      minWidth: 170,
    },
    {
      id: 'country',
      label: t('country'),
      minWidth: 170,
    },
  ]

  const handleChangePage = (newPage: number) => {
    if (newPage > 0 && newPage <= pagination.totalPages) {
      if (query) {
        navigate(`/place?page=${newPage}&search=${query}`)
      } else {
        navigate(`/place?page=${newPage}`)
      }
    }
  }

  const handleSearch = (query?: string) => {
    if (query && query.length > 2) {
      navigate(`/place?search=${query}`)
    } else {
      navigate('/place')
    }
  }

  const handleNavigate = (id: string) => {
    localStorage.setItem('placesListingPage', location.search)
    navigate(`/place/${id}/info`)
  }

  const handleOpenModal = () => {
    setModal({ right: true })
  }
  const handleCloseModal = () => {
    setModal({ right: false })
  }

  const getValue = (place: Place, id: string) => {
    const data = id.split('.').reduce((p, prop) => {
      return p[prop as keyof typeof place] as unknown as Place
    }, place)

    return data
  }

  if (error) return <h1>Error</h1>
  if (isLoading || !places) return <LoadingIndicator />

  return (
    <Box m={4}>
      <ListingPage
        tableWidth='calc(100vw - 64px - 40px)'
        columns={columns}
        listItems={places}
        handleNavigate={handleNavigate}
        header={
          <PlacesHeader
            query={query}
            hasListItems={Boolean(places && places.length > 0)}
            handleSearch={handleSearch}
            handleOpenModal={handleOpenModal}
          />
        }
        query={query || undefined}
        pagination={pagination}
        page={Number(pageIndex) || 1}
        handleChangePage={handleChangePage}
        displayValues={getValue}
      />
      <NewPlaceModal handleCloseModal={handleCloseModal} modal={modal} />
    </Box>
  )
}
